import arrowButtonOuterLayer from '@assets/intro-screen/arrow-button-outer-layer.svg'
import arrowButtonFirstInnerLayer from '@assets/intro-screen/arrow-button-first-inner-layer.svg'
import arrowButtonInnerShadow from '@assets/intro-screen/arrow-button-inner-shadow.svg'
import arrowButtonArrow from '@assets/intro-screen/arrow-button-arrow.svg'
import arrowButtonHover from '@assets/intro-screen/arrow-button-hover.svg'

import React, { MouseEvent, useState } from 'react'
import { BuildGradientStyle } from '@utils/buildGradientStyle'
import { useConfigurationStore } from '@stores/index'
import { ViewportType } from 'game-ui-types'

type ArrowButtonProps = {
    onClick: (event: MouseEvent, number: number) => void
    innerLayerStyle: BuildGradientStyle
    disabled: boolean
    className: string
    isDecrement?: boolean
}

export const ArrowButton: React.FC<ArrowButtonProps> = (props) => {
    const viewport = useConfigurationStore((s) => s.viewport)

    const [isMouseOverButton, setIsMouseOverButton] = useState(false)

    const { disabled, isDecrement, className, onClick, innerLayerStyle } = props

    return (
        <button
            className={className}
            onClick={(e) => onClick(e, isDecrement ? -1 : 1)}
            onMouseEnter={() => setIsMouseOverButton(true)}
            onMouseLeave={() => setIsMouseOverButton(false)}
            disabled={disabled}
            style={{ opacity: disabled ? 0.5 : 1 }}
        >
            <img src={arrowButtonOuterLayer} />
            <img className="absolute top-[4px] left-[4px]" src={arrowButtonFirstInnerLayer} />
            <div
                className="absolute left-[5px] top-[5px] h-[60px] w-[60px] rounded-[30px]"
                style={innerLayerStyle}
            ></div>
            <img className="absolute left-[5px] top-[5px]" src={arrowButtonInnerShadow} />
            <img className="absolute left-[28px] top-[21px]" src={arrowButtonArrow} />
            {isMouseOverButton && !disabled && viewport === ViewportType.DESKTOP && (
                <img className="absolute left-[5px] top-[5px]" src={arrowButtonHover} />
            )}
        </button>
    )
}
